import moment from "moment";
import {
  texto,
  identificador,
  moneda,
  fechaMexico,
  fechaHoraMexico,
  totalizar,
  construirHojaTabla,
  limpiarNombreArchivo,
  descargarLibro,
} from "../../../../Components/ExcelTablaReporte";

/**
 * Excel del Reporte Referencias De Pago (modulo Escuela).
 *
 * Un renglon por referencia; los alumnos sin referencia salen con la referencia
 * en gris y el resto de las columnas de la referencia vacias.
 */

const COLUMNAS = [
  { titulo: "Referencia", tipo: "identificador", ancho: 22 },
  { titulo: "Metodo", tipo: "texto", ancho: 32 },
  { titulo: "Estado", tipo: "texto", ancho: 12 },
  { titulo: "Motivo Cancelacion", tipo: "texto", ancho: 34 },
  { titulo: "Generada", tipo: "fechaHora", ancho: 17 },
  { titulo: "Vence", tipo: "fechaHora", ancho: 17 },
  { titulo: "Fecha De Pago", tipo: "fecha", ancho: 13 },
  { titulo: "Folio Venta", tipo: "texto", ancho: 14 },
  { titulo: "Total A Pagar", tipo: "moneda", ancho: 16 },
  { titulo: "Matricula(s)", tipo: "identificador", ancho: 20 },
  { titulo: "Alumno(s)", tipo: "texto", ancho: 40 },
  { titulo: "Escuela(s)", tipo: "texto", ancho: 28 },
  { titulo: "Grupo(s)", tipo: "texto", ancho: 18 },
  { titulo: "Paquete(s)", tipo: "texto", ancho: 32 },
  { titulo: "Generada Por", tipo: "texto", ancho: 32 },
  { titulo: "Correo", tipo: "texto", ancho: 30 },
  { titulo: "Telefono", tipo: "identificador", ancho: 16 },
];

const GRIS = "#8C8C8C";

export const construirTabla = (filas) => {
  const cuerpo = (filas || []).map((fila) => {
    if (fila.sinReferencia) {
      return [
        { ...texto("Sin referencia"), colorTexto: GRIS },
        texto(""),
        texto(""),
        texto(""),
        texto(""),
        texto(""),
        texto(""),
        texto(""),
        moneda(null),
        identificador(fila.matriculas),
        texto(fila.alumnos),
        texto(fila.escuelas),
        texto(fila.grupos),
        texto(""),
        texto(""),
        texto(""),
        identificador(""),
      ];
    }

    const celdas = [
      identificador(fila.referencia),
      texto(fila.metodoEtiqueta),
      texto(fila.estadoReferencia),
      texto(fila.motivoCancelacion),
      fechaHoraMexico(fila.fechaGeneracion),
      fechaHoraMexico(fila.fechaVence),
      fechaMexico(fila.fechaPago),
      texto(fila.folio),
      moneda(fila.totalPagar),
      identificador(fila.matriculas),
      texto(fila.alumnos),
      texto(fila.escuelas),
      texto(fila.grupos),
      texto(fila.paquetes),
      texto(fila.generadaPor),
      texto(fila.correo),
      identificador(fila.telefono),
    ];

    return fila.estadoReferencia === "Cancelada"
      ? celdas.map((celda) => ({ ...celda, resalte: "nota" }))
      : celdas;
  });

  // El total se arma a mano: una referencia cancelada ya no se va a cobrar y no
  // debe sumar al total generado (mismo criterio que el indicador de la pantalla).
  const indiceTotal = COLUMNAS.findIndex((columna) => columna.titulo === "Total A Pagar");
  const vigentes = cuerpo.filter(
    (_, indice) => !filas[indice].sinReferencia && filas[indice].estadoReferencia !== "Cancelada"
  );
  const totales = COLUMNAS.map(() => null);
  totales[indiceTotal] = totalizar(COLUMNAS, vigentes)[indiceTotal];

  return { columnas: COLUMNAS, filas: cuerpo, totales };
};

export const descargarExcel = ({ filas, empresaNombre, descripcionFiltros }) => {
  descargarLibro(
    [
      {
        nombre: "Referencias De Pago",
        hoja: construirHojaTabla(construirTabla(filas), {
          titulo: "Referencias de pago generadas a alumnos",
          empresaNombre,
          descripcionFiltros,
        }),
      },
    ],
    `Referencias_De_Pago_${limpiarNombreArchivo(empresaNombre)}_${moment().format("YYYY-MM-DD")}`
  );
};
